// FORMATS
export const FORMAT_CON_GUIONES = 'YYYY-MM-DD';
export const FORMAT_DATE_CALENDAR = "dd-MM-yyyy";

// MONTHS
export const MONTH_NAMES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];